import { ReactNode, useCallback, useState } from "react";
import { NavLink } from "react-router";
import t from "@/lang/lang";
import { useOmniBaseDataServiceKind } from "../use-omni-base-data-service-kind";
import {
  PositionsBaseDataTable,
  PositionsBaseDataTableFilters,
  defaultOmniPositionsBaseDataListRequest,
} from "@/services/backend/omni/position/components/positions-base-data-table";
import { CreatePositionsBaseDataDialog } from "@/services/backend/omni/position/components/create-positions-base-data-dialog";
import {
  Card,
  CardAction,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/shared/components/ui/card";

export function OmniPositionsBaseDataRoute() {
  const serviceKind = useOmniBaseDataServiceKind();
  const [request, setRequest] = useState(
    defaultOmniPositionsBaseDataListRequest(serviceKind),
  );

  const renderRowLink = useCallback(
    (baseDataId: string, children: ReactNode) => (
      <NavLink to={baseDataId}>{children}</NavLink>
    ),
    [],
  );

  return (
    <Card>
      <CardHeader>
        <CardTitle>{t("Positionen")}</CardTitle>
        <CardDescription>
          {t(
            "Hier können Sie die Positionen verwalten, die beim Hinzufügen von Positionen angeboten werden. Ein Leistungsverzeichnis bietet die Positionen der Basisdaten seiner Variation an, ohne solche die als aktiv markierten Basisdaten.",
          )}
        </CardDescription>
        <CardAction>
          <CreatePositionsBaseDataDialog serviceKind={serviceKind} />
        </CardAction>
      </CardHeader>
      <CardContent className="grid gap-2">
        <PositionsBaseDataTableFilters
          request={request}
          onRequestChange={setRequest}
        />
        <PositionsBaseDataTable
          request={request}
          onRequestChange={setRequest}
          renderRowLink={renderRowLink}
        />
      </CardContent>
    </Card>
  );
}
